import UseContext from "../../../hooks/useContext";
import SlideOverExportMission from "./data/slideOverExportMission/SlideOverExportMission";

const dataSlideOver = new Map();
dataSlideOver.set("export_missions", <SlideOverExportMission />);

const DataSlideOver = () => {
  const { slideOverType } = UseContext();
  return <>{dataSlideOver.get(slideOverType)}</>;
};

export default DataSlideOver;
